import React from "react";
import "./GetMusicOnGionee.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnGionee = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Gionee Distribution",
    "Music delivered to Gionee ecosystem",
    "Reach mobile listeners worldwide",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Gionee Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to Gionee mobile devices worldwide with FT Tunes and reach millions of listeners."
        />

        <meta
          name="keywords"
          content="Gionee music distribution, mobile music distribution, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="gionee-page">

        {/* HERO */}
        <section className="gionee-hero">
          <Container>

            <img
              src="/Images/gionee-logo.png"
              alt="Gionee"
              className="gionee-logo"
            />

            <h1>Distribute Your Music on Gionee Devices</h1>

            <p>
              Deliver your music across Gionee smartphones and
              connected mobile ecosystems reaching global listeners.
            </p>

            <Button
              className="gradient-btn-gionee"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-gionee"></div>
        </section>


        {/* SHOWCASE */}
        <section className="gionee-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Millions of Mobile Music Fans</h2>

                <p>
                  Gionee devices deliver immersive entertainment
                  experiences. Make your music available directly
                  to smartphone users worldwide.
                </p>

                <Button
                  className="outline-btn-gionee"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-gionee.png"
                  alt="Gionee Distribution"
                  className="gionee-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="gionee-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-gionee">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="gionee-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Gionee
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-gionee">
                  <h5>Mobile First Audience</h5>
                  <p>Reach smartphone listeners globally.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gionee">
                  <h5>Global Reach</h5>
                  <p>Millions of active mobile users.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gionee">
                  <h5>Fast Delivery</h5>
                  <p>Optimized mobile playback experience.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-gionee">
                  <h5>Revenue Tracking</h5>
                  <p>Monitor streams & earnings easily.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="gionee-cta">
          <Container>

            <h2>Start Your Gionee Music Distribution Today</h2>

            <Button
              className="gradient-btn-gionee big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnGionee;